import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState} from '../../../app/store';
import {  getStandardKycRequestDetails } from '../apis/StandarKycApi';
import { GetAllResourceResponse } from '../apis/models/GetAllResourceResponse';


export interface StandardKycState {
  standardKycDetails: GetAllResourceResponse,
  loading: 'idle' | 'loading' | 'failed';
  error : any
}

const initialState: StandardKycState = {
  standardKycDetails: null as any,
  loading: 'idle',
  error : null
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.

export const getStandardKycRequestDetailsAsync = createAsyncThunk(
  'consent/getStandardKycRequestDetailsAsync',
  async (requestId: string) => {
    const response = await getStandardKycRequestDetails(requestId);

    return response;
  }
);

export const standardKycSlice = createSlice({
  name: 'standardKyc',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setStandarKycDetails:(state, action: PayloadAction<any>) => {
      state.standardKycDetails = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getStandardKycRequestDetailsAsync.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(getStandardKycRequestDetailsAsync.fulfilled, (state, action) => {
        state.loading = 'idle';
        state.standardKycDetails = action.payload;
      })
      .addCase(getStandardKycRequestDetailsAsync.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message;
      })
  }
});

export const { setStandarKycDetails } = standardKycSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStandarKycDetails = (state: RootState) => state.standardKyc;

export default standardKycSlice.reducer;